// How one offboarding account stands, as a pure function of the account. Split
// out of useOffboardingChecklist so the terminal statuses can be pinned by a
// test: importing the hook pulls in the members API module, which needs a
// browser, and this repo's vitest runs in `node`.

import type { MFOffboardingAccount } from "state/members/tasks";

export type OffGroupKey = "admin" | "removal";

// A row's standing within a given group: still actionable, finished, declined
// (the account was refused) or cancelled (an admin called the deprovisioning
// off entirely, PLO-5978). The last two are terminal in both groups; they are
// kept apart because only one of them is something this member did.
export type OffRowState = "pending" | "done" | "declined" | "cancelled";

// Per-group standing for one account.
export const rowState = (
  group: OffGroupKey,
  a: MFOffboardingAccount,
): OffRowState => {
  if (a.status === "declined") return "declined";
  if (a.status === "cancelled") return "cancelled";
  if (a.status === "complete") return "done"; // removed -> both groups resolved
  if (group === "removal") return "pending";
  // admin group, account still incomplete:
  return a.checklist.adminRightsConfirmedAt ||
    a.checklist.adminTransferNotRequired
    ? "done"
    : "pending";
};

// Accounts still asking something of this member. Declined and cancelled are
// resolved: one was refused, the other was called off, and neither is work.
export const outstandingCount = (accounts: MFOffboardingAccount[]): number =>
  accounts.filter((a) => a.status === "incomplete").length;
